import React from 'react';
import logo from '../../../assets/img/4SRealEstate_MultipleLines.png';
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog } from '@fortawesome/free-solid-svg-icons';
import ButtonProfile from '../ButtonProfile';
import ModalConfirmCloseSession from '../ModalConfirmCloseSession';
import './styles.css';

const HeaderDemand = () => {

  const location = useLocation();

  return (
    <>
      <header className="row py-4 px-md-5" id='headerDemand'>
        <div className="container">

          <div className="col-4 text-center text-md-left">
            <Link to="/home">
              <img className="home-logo" src={logo} alt="" style={{ filter: "invert(1)", width: "17.1em" }} />
            </Link>
            <span className='headerNameSeparatorLine'></span>
            <h1 className="headerName">SIGII</h1>
          </div>

          <div className="col-12 col-md-8 text-right pt-3">

            <Link to="/demandImporter/importers">
              <button
                className={`btn btn-primary mx-2 textBig ${location.pathname === "/demandImporter/importers" ? "active-link" : ""
                  }`}
              >
                Importadores
              </button>
            </Link>

            <Link to="/liftingReview">
              <button
                className={`btn btn-primary mx-2 textBig ${location.pathname === "/liftingReview" ? "active-link" : ""
                  }`}
              >
                Auditoría
              </button>
            </Link>

            <Link to="/admin/users">
              <button className="btn btn-primary iconBig" style={{ marginLeft: "2rem" }} onClick={() => true}>
                <FontAwesomeIcon icon={faCog} />
              </button>
            </Link>

            <ButtonProfile />

          </div>
        </div>
      </header>

      <div className="container">
        <ModalConfirmCloseSession />
      </div>
    </>
  );
}

export default HeaderDemand;
